import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import GlobalErrorBoundary from './components/GlobalErrorBoundary'
import './index.css'
import './i18n'
import App from './App.tsx'

// Prevent downloading/right-clicking on images globally
document.addEventListener('contextmenu', (e) => {
  if ((e.target as HTMLElement).tagName === 'IMG') {
    e.preventDefault()
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <GlobalErrorBoundary>
        <App />
      </GlobalErrorBoundary>
    </HelmetProvider>
  </StrictMode>,
)
